// src/components/AlertImageModal.js
import React, { useState } from 'react';
import styles from '../styles/AlertImageModal.module.css';

const AlertImageModal = ({
  isOpen,
  message, // 现在可以支持JSX内容
  imageUrl,
  onClose,
  onConfirm,
  confirmText = '确定',
}) => {
  const [showLargeImage, setShowLargeImage] = useState(false);
  
  if (!isOpen) return null;

  // 默认关闭弹窗，如果传入 onConfirm，则执行自定义行为
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <button className={styles.closeBtn} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
          <h2>使用教程</h2>
          {imageUrl && (
            <div className={styles.imageContainer}>
              <img 
                src={imageUrl} 
                alt="提示图片" 
                className={styles.modalImage} 
                onClick={() => setShowLargeImage(true)}
              />
              <span className={styles.imageCaption}>点击查看大图</span>
            </div>
          )}
          <div className={styles.messageContent}>{message}</div>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.btn} onClick={handleConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
      
      {showLargeImage && imageUrl && (
        <div className={styles.fullscreenImage} onClick={() => setShowLargeImage(false)}>
          <button className={styles.closeFullscreenBtn} onClick={() => setShowLargeImage(false)}>
            <i className="fas fa-times"></i>
          </button>
          <img src={imageUrl} alt="大图查看" />
        </div>
      )}
    </div>
  );
};

export default AlertImageModal;